const logger = (level, ...args) => {
	if (process.env.NODE_ENV !== "production") {
		window.console[level](...args);
	}
};

export default logger;
